<button class="button custom-nav-button" [class.is-bold]="isBold" [ngStyle]="getStyle()">
    <div style="display: flex; flex-direction: row; align-items: center">
        <i *ngIf="isPrev" [ngStyle]="getChevronStyle()" class="fas fa-chevron-left"></i><span style="margin-left: 1em; margin-right: 1em"><tra [slug]="text"></tra></span><i *ngIf="!isPrev" [ngStyle]="getChevronStyle()" class="fas fa-chevron-right"></i>
    </div>
</button>
